module.exports = __webpack_public_path__ + "img/ca.5fac7837.png";